"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[378],{

/***/ 46390:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64799);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24828);
/* harmony import */ var src_hooks_use_account__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53082);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25349);
/* harmony import */ var src_hooks_use_matched_route__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42281);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21541);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94141);
/* harmony import */ var src_ui_list_layouts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47252);
/* harmony import */ var src_components_page_page_content__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53170);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62619);
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24005);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25670);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 50%;\n    height: 70vh;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var getErrorMessage = function(error) {
    switch(error){
        case "oauth-state-mismatch":
            return "error.oauth-state-mismatch";
        default:
            return "error.default";
    }
};
var PageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(src_ui_list_layouts__WEBPACK_IMPORTED_MODULE_9__/* .ColumnWithGutter */ .U).withConfig({
    displayName: "PageWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_8__/* .layout.measurements.spacing400 */ .bK.measurements.spacing400, src_components_base__WEBPACK_IMPORTED_MODULE_8__/* .layout.measurements.spacing400 */ .bK.measurements.spacing400, src_components_base__WEBPACK_IMPORTED_MODULE_8__/* .media.mediumUp */ .BC.mediumUp(_templateObject()));
var AuthenticationError = function(param) {
    var error = param.error;
    var login = (0,src_hooks_use_account__WEBPACK_IMPORTED_MODULE_4__/* .useAccount */ .m)().login;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_5__/* .useAppContext */ .bp)().t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_7__.H1Text, {
        flex: false
    }, t("errors", "internal.unknown")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_7__.BodyMediumText, {
        flex: false
    }, t("account", getErrorMessage(error))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_7__.CaptionText, {
        flex: false
    }, t("errors", "error-page.error-code", {
        code: error.length > 0 ? error : "unspecified"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_13__.PrimaryButton, {
        fullWidth: true,
        onClick: function() {
            (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_12__/* .pushEvent */ .A)("login", {
                loggedIn: true
            });
            login();
        }
    }, t("account", "login.submit-button")));
};
var AccountLoginError = function() {
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_5__/* .useAppContext */ .bp)().market;
    var replace = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .k6)().replace;
    var route = (0,src_hooks_use_matched_route__WEBPACK_IMPORTED_MODULE_6__/* .useMatchedRoute */ .M)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.areas.account;
    }), loading = ref.loading, isAuthenticated = ref.isAuthenticated;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (market.login.enabled && !loading) {
            if (isAuthenticated) {
                replace("/");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading
    ]);
    var error = route.match.params.error || "";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_page_page_content__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageWrapper, {
        gap: 1
    }, loading ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, null) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AuthenticationError, {
        error: error
    })));
};
/* harmony default export */ __webpack_exports__["default"] = (AccountLoginError);


/***/ }),

/***/ 13971:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64799);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24828);
/* harmony import */ var src_hooks_use_account__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53082);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25349);
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24005);






var AccountLoginRedirect = function() {
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_4__/* .useAppContext */ .bp)().market;
    var login = (0,src_hooks_use_account__WEBPACK_IMPORTED_MODULE_3__/* .useAccount */ .m)().login;
    var replace = (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .useHistory */ .k6)().replace;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.areas.account;
    }), loading = ref.loading, isAuthenticated = ref.isAuthenticated;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (market.login.enabled && !loading) {
            if (!isAuthenticated) {
                (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_5__/* .pushEvent */ .A)("login", {
                    loggedIn: true
                });
                login();
            } else {
                replace("/");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading
    ]);
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (AccountLoginRedirect);


/***/ }),

/***/ 47252:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ ListMobileColumnElseRow),
/* harmony export */   "U": () => (/* binding */ ColumnWithGutter)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63226);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29261);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ColumnWithGutter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__.Column).withConfig({
    displayName: "ColumnWithGutter",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ListMobileColumnElseRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__.List).withConfig({
    displayName: "ListMobileColumnElseRow",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .media.mediumUp */ .BC.mediumUp(_templateObject1()));


/***/ })

}]);